var MILLIS_IN_A_DAY = 24 * 60 * 60 * 1000;
function getTimelineWidth(settings) {
    var start = settings.start, end = settings.end, zoom = settings.zoom, _a = settings.viewportWidth, viewportWidth = _a === void 0 ? 0 : _a, _b = settings.minWidth, minWidth = _b === void 0 ? 0 : _b;
    var duration = end.valueOf() - start.valueOf();
    var days = duration / MILLIS_IN_A_DAY;
    var daysZoomWidth = days * zoom;
    if (daysZoomWidth > viewportWidth) {
        return daysZoomWidth >= minWidth ? daysZoomWidth : minWidth;
    }
    else {
        return viewportWidth >= minWidth ? viewportWidth : minWidth;
    }
}
var create = function (settings) {
    var start = settings.start, end = settings.end, zoom = settings.zoom;
    var duration = end.valueOf() - start.valueOf();
    var timelineWidth = getTimelineWidth(settings);
    var timelineWidthStyle = "".concat(timelineWidth, "px");
    var toX = function (from) {
        var value = (from.valueOf() - start.valueOf()) / duration;
        return Math.round(value * timelineWidth);
    };
    var toStyleLeft = function (from) { return ({
        left: "".concat(toX(from), "px"),
    }); };
    var toStyleLeftAndWidth = function (from, to) {
        var left = toX(from);
        return {
            left: "".concat(left, "px"),
            width: "".concat(toX(to) - left, "px"),
        };
    };
    var fromX = function (x) { return new Date(start.getTime() + (x / timelineWidth) * duration); };
    return {
        timelineWidth: timelineWidth,
        timelineWidthStyle: timelineWidthStyle,
        start: start,
        end: end,
        zoom: zoom,
        toX: toX,
        toStyleLeft: toStyleLeft,
        toStyleLeftAndWidth: toStyleLeftAndWidth,
        fromX: fromX,
    };
};
export default create;
